import React from 'react';
import { injectIntl } from 'react-intl';
import { Grid } from 'semantic-ui-react';
//noinspection NpmUsedModulesInstalled
import { flattenToAppURL, getColor } from '@plone/volto/helpers';
//noinspection NpmUsedModulesInstalled
import { Avatar, FormattedDate } from '@plone/volto/components';
import DownloadIcon from './DownloadIcon';
import { showDownloadDetails } from '../actions';
import { useDispatch } from 'react-redux';

const DownloadItem = ({ data, isEditMode, preventDefault }) => {
  const dispatch = useDispatch();

  if (!data) {
    return null;
  }

  return (
    <Grid.Row className={'download-info'}>
      <Grid.Column computer={1} tablet={1} mobile={1} className={'download-mime-type'}>
        <DownloadIcon mimetype={data['mime_type']} />
      </Grid.Column>
      <Grid.Column
        computer={8}
        tablet={8}
        mobile={5}
        textAlign="left"
        className={'download-title'}
        onClick={(e) => {
          if (preventDefault) {
            e.preventDefault();
          }
          !!data.UID && dispatch(showDownloadDetails(data.UID));
        }}
      >
        {data['title']}
      </Grid.Column>
      <Grid.Column computer={2} tablet={2} mobile={3} className={'download-creation-date'}>
        <FormattedDate date={data['CreationDate']} />
      </Grid.Column>
      <Grid.Column computer={1} tablet={1} mobile={2} className={'download-author'}>
        <Avatar
          src={flattenToAppURL('/@portrait/' + data['Creator'])}
          title={data['Creator']}
          color={getColor(data['Creator'])}
          userId={data['Creator']}
          preventDefault
        />
      </Grid.Column>
    </Grid.Row>
  );
};

export default injectIntl(DownloadItem);
